import React, { useEffect, useState } from 'react';
import MuiAlert, { AlertProps as AlertDirectUsageProps } from '@mui/material/Alert';
import Grow from '@mui/material/Grow';
import { AlertLayoutProps } from 'framework/ui/uiContract/uiContract';

const Alert = (props: AlertDirectUsageProps | AlertLayoutProps) => {
  const [showAlert, setShowAlert] = useState(false);
  const alertProps = {
    ...props,
    sx: {
      marginBottom: '1rem',
      ...('sx' in props ? props.sx : undefined),
    },
  };

  useEffect(() => {
    setShowAlert(true);
  }, []);

  return showAlert ? (
    <Grow timeout={300} in={showAlert}>
      <MuiAlert {...alertProps} />
    </Grow>
  ) : null;
};

export default Alert;
